/* eslint-disable react/prop-types */
/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";

import RenderToolTip from "../../../component/tooltip/RenderToolTip";
import TextInput2 from "../../../component/input/TextInput2";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../../constant/helper/helper";
import SpinnerButton from "../../../component/spinner/SpinnerButton";
import Button from "../../../component/button/Button";
import { toolTipData } from "./queryStaticData";
import SelectInput2 from "../../../component/input/SelectInput2";

const TopInput = ({
  values,
  loading,
  onSubmit,
  onChange,
  currentUser,
  allLocations
}) => {
  return (
    <div className="row">
      <RenderToolTip toolTipData={toolTipData} />

      <div className="col-md-3 col-xl-3 col-lg-3">
        <SelectInput2
          data-tip
          name="dataTypes"
          isLabeled={true}
          onChange={onChange}
          icon="mdi mdi-map-marker-radius"
          data-for="dataTypes"
          label="Select Type"
          value={values.dataTypes}
          placeholder="Select Type"
        >
          <option value="ALL">ALL</option>
          <option value="DATE">DATE</option>
        </SelectInput2>
      </div>
      {values.dataTypes === "DATE" && (
        <Fragment>
          <div className="col-3">
            <TextInput2
              type="date"
              name="date"
              data-for="date"
              onChange={onChange}
              value={values.date}
              placeholder="Select Date"
              icon="mdi mdi-calendar-check"
            />
          </div>

          <div className="col-3">
            <SelectInput2
              data-tip
              name="locationId"
              isLabeled={true}
              onChange={onChange}
              icon="mdi mdi-map-marker-radius"
              data-for="locationName"
              label="Select Location"
              value={values.locationId}
              placeholder="Select Location"
            >
              {isSuperAdmin(currentUser)
                ? renderLocationFunction(allLocations)
                : renderAccessLocation2(
                    locationRender(currentUser, false)
                  )}
            </SelectInput2>
          </div>
        </Fragment>
      )}

      {loading === true ? (
        <div className="col-sm-2">
          <SpinnerButton />
        </div>
      ) : (
        <div className="col-lg-2 col-md-2">
          <div className="form-group">
            <Button
              title="GET"
              type="button"
              onClick={onSubmit}
              isBackgroundColor={false}
              icon="mdi mdi-plus-circle-outline mr-2"
              className="btn mb-2 text-white btn-dark btn-block"
            />
          </div>
        </div>
      )}
      <div className="col-lg-4 col-md-4">
        <TextInput2
          data-tip
          type="text"
          name="Filter"
          data-for="Filter"
          onChange={onChange}
          value={values.Filter}
          icon="mdi mdi-table-search"
          placeholder="Search..."
        />
      </div>
    </div>
  );
};

TopInput.propTypes = {
  loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};

export default TopInput;
